// extracted by mini-css-extract-plugin
module.exports = {"heading":"_38JPmO7VD3nuPXfe-S5bEU","frameResizer":"_1W-mEhPHbC7yol-ESQ7Ho3","frame":"_3B602ZOFoiPFg1I3J1EUy8"};